import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputBase, TextField } from "@mui/material";
import { useMutation } from "react-query";
import { SearchProducts } from "../service/store.service";
import { SearchProductsResponse } from "../models/store.model";
import { useDebouncedCallback } from "use-debounce";
import { useHistory } from "react-router-dom";
import ArrowLeftRoundedIcon from "@mui/icons-material/ArrowLeftRounded";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useOutsideClick } from "../hooks/useOutsideClick";

const SearchField = () => {
  const history = useHistory<{
    parentCategoryId: number;
    filter?: string;
    title?: string;
  }>();

  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState<SearchProductsResponse>();
  const [showSearchbar, setShowSearchbar] = useState(false);
  const [parentCategoryId, setParrentCategoryId] = useState<number>();
  const ref = useOutsideClick(() => {
    setShowSearchbar(false);
    setSearchData({ ...searchData!, searchResult: [] });
    setSearch("");
  });

  useEffect(() => {
    setSearch(
      history.location.state?.filter ? history.location.state.filter : ""
    );
  }, []);
  const handleChange = (e: any) => {
    setSearch(e.target.value);
    sendSearchTerm(e.target.value);
  };

  const { mutate: SearchProductsMutate, isLoading } = useMutation(
    SearchProducts,
    {
      onSuccess: (data: SearchProductsResponse) => {
        if (data) {
          setSearchData(data);
        }
      },
      onError: () => {},
    }
  );

  const sendSearchTerm = useDebouncedCallback((text: string) => {
    if (text !== "") {
      SearchProductsMutate({
        // productCategoryId: categoryId!,
        filter: text,
      });
    }
  }, 1000);

  const handleRouteToProduct = (id: number, filter: string) => {
    if (parentCategoryId !== id) {
      history.replace({
        pathname: "/products/productCategory1/Productlist",
        state: {
          parentCategoryId: id,
          filter: filter,
        },
      });
    }
  };
  const handleRouteToCategory = (id: number, title: string) => {
    if (parentCategoryId !== id) {
      history.replace({
        pathname: "/products/productCategory1/productCategoryCard",
        state: {
          parentCategoryId: id,
          title: title,
        },
      });
    }
  };

  useEffect(() => {
    setParrentCategoryId(history.location.state?.parentCategoryId!);
  }, [history.location]);

  return (
    <Box
      className="search"
      position={"relative"}
      sx={{ maxWidth: "550px", height: "40px" }}
    >
      <Grid
        item
        xs={12}
        className={showSearchbar ? "search-results" : "store-search"}
        ref={ref}
        onClick={() => setShowSearchbar(true)}
        sx={{
          position:
            (search !== "" && searchData?.searchResult.length! > 0) ||
            (search !== "" && searchData?.foundAny === false)
              ? "absolute"
              : "",
        }}
      >
        <SearchIcon />
        <InputBase
          type="text"
          autoComplete="off"
          className="live-search-field"
          placeholder="جستجو"
          autoFocus={showSearchbar}
          style={{
            color: "#424242",
            fontSize: "14px",
            marginRight: "10px",
          }}
          sx={{
            input: {
              color: "#424242",
              "&::placeholder": {
                opacity: 1,
              },
            },
            backgroundColor: showSearchbar
              ? "#fff !important"
              : "#f0f0f1 !important",
          }}
          onChange={handleChange}
          value={search}
          readOnly={!showSearchbar}
        />

        {search !== "" && searchData?.searchResult.length! > 0 && (
          <CloseOutlinedIcon
            sx={{
              position: "absolute",
              top: "7px",
              left: "20px",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowSearchbar(false);
              setSearchData({ ...searchData!, searchResult: [] });
              setSearch("");
            }}
          />
        )}
        {/* search results */}
        {!isLoading ? (
          showSearchbar &&
          search !== "" &&
          searchData && (
            <Box
              //  className="search-results"
              sx={{
                position: "relative",
                borderTop:
                  searchData?.searchResult.length! > 0
                    ? "1px solid #19BFD3"
                    : "",
                marginTop: "1rem",
              }}
            >
              {searchData?.searchResult.map((result) => (
                <Grid container flexDirection={"column"} marginY={"15px"}>
                  <Grid
                    item
                    sx={{ fontWeight: "bold", cursor: "pointer" }}
                    onClick={() => {
                      handleRouteToProduct(
                        result.productCategoryId,
                        result.filter
                      );
                    }}
                  >
                    <SearchIcon
                      sx={{
                        color: "#9E9E9E",
                        marginLeft: "15px",
                        marginRight: "17px",
                        fontWeight: "bold",
                      }}
                    />

                    {result.filter}
                  </Grid>
                  <Grid
                    item
                    sx={{
                      "&:hover": { cursor: "pointer" },
                    }}
                  >
                    <Grid container alignItems={"center"} marginRight={"23px"}>
                      <Grid item sx={{ marginX: "7px", color: "#9E9E9E" }}>
                        در دسته بندی
                      </Grid>

                      {result.productCategoryPath.map((productPath, index) => (
                        <Grid
                          item
                          sx={{
                            // marginX: "7px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#19BFD3",
                          }}
                        >
                          {index >= 1 && (
                            <ArrowLeftRoundedIcon sx={{ fontSize: "30px" }} />
                          )}
                          <Typography
                            sx={{ fontWeight: "bold" }}
                            onClick={() => {
                              setShowSearchbar(false);
                              setSearchData({
                                ...searchData!,
                                searchResult: [],
                              });
                              setSearch("");
                              handleRouteToCategory(
                                productPath.key,
                                productPath.value
                              );
                            }}
                          >
                            {productPath.value}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              ))}

              {/* nothing found */}
              {searchData?.foundAny === false && (
                <Grid
                  container
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  marginY={"15px"}
                  gap={"1rem"}
                >
                  <Grid item>
                    <img alt="not found" src="./images/notfound.png" />
                  </Grid>
                  <Grid item fontWeight={"400"} fontSize={"20px"}>
                    نتیجه‌ای یافت نشد!
                  </Grid>
                  <Grid item fontSize={"14px"} color={"#757575"}>
                    از عبارت‌های متداول‌تر استفاده کنید یا املای عبارت وارد شده
                    را بررسی کنید
                  </Grid>
                </Grid>
              )}
            </Box>
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SearchIcon sx={{ marginLeft: "7px" }} />
            <Typography marginLeft={"25px"} fontSize={"1.1rem"}>
              در حال جستجو
            </Typography>
            <div className="search-loader"></div>
          </Box>
        )}
      </Grid>
      {/* suggestion results */}
      {/* <div>
        {searchData.map((data: any, index: number) => (
          <a href={data.show.url} key={index} target="_blank">
            {data.show.name}
          </a>
        ))}
      </div> */}
    </Box>
  );
};

export default SearchField;
